// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"ReviewSlider_bannerImage__2B_Ev","noBorder":"ReviewSlider_noBorder__1-8bv"};